export const breakpoints = {
  mobile: 320,
  tablet: 640,
  laptop: 960,
  desktop: 1280,
  wide: 1600,
};
